<script setup>

import { getCurrentInstance, onMounted } from "vue";
const appInstance = getCurrentInstance();
const emitter = appInstance.appContext.config.globalProperties.emitter;
import ClearCartButton from "@/Components/ECart/Reusable/ClearCartButton.vue";
import { store as storeConfig } from "~app_root/public/tv/app.config";

onMounted(() => {
	emitter.emit('cartItemHideDeleteConfirmation');
});

import { Link } from '@inertiajs/vue3';
import CartItem from './CartItem.vue';

</script>

<template>
	<div>

		<transition name="slide-right">
			<div class="minicart-extended" v-if="uicontrol.show">

				<div class="minicart-extended-header">

					<h4 class="title font-medium">
						<span class="me-1">{{ $store.state.cart.items_quantity }}</span>
						<span v-if="$store.state.cart.items_quantity !== 1">{{ __('items') }}</span>
						<span v-else>{{ __('item') }}</span>
					</h4>

					<ClearCartButton v-if="storeConfig.clear_cart_button" />

				</div>



				<i class="close_overlay_container right lnr icon-cross" @click="$emit('hide_minicart_extended')"></i>

				<div class="buttons d-flex flex-column flex-lg-row justify-content-between mb-4"
					v-if="$store.state.cart.items.length >= 7 && !$store.getters['cart/hasInvalidItems']">

					<Link :href="route('cart')" class="btn btn-secondary me-2 font-semibold flex-fill">
					{{ __('view_cart') }}
					</Link>

					<Link :href="route('checkout')" class="btn btn-primary me-2 font-semibold flex-fill">
					{{ __('proceed_to_checkout') }}
					</Link>

				</div>

				<ul class="items" v-if="$store.state.cart.items.length">
					<CartItem v-for="(item, itemKey) in $store.state.cart.items" :key="item.uuid" :item="item" :options="{
						'delete_button': true,
						'quantity_controls': true
					}"></CartItem>
				</ul>

				<div class="cart-empty-message-container" v-else>
					<span>
						{{ __('cart_empty') }}
					</span>
				</div>

				<CartStats :hideShippingIfZero="true" />

				<!-- Shows message saying cart has unavailable items and shows button to delete unavailable items -->
				<InvalidItemsResolver />

				<div class="buttons d-flex  flex-column justify-content-between" v-if="$store.state.cart.items.length">

					<Link :href="route('cart')" class="btn btn-secondary me-2 font-semibold mb-2">
					<i class="lnr icon-cart"></i> {{ __('view_cart') }}
					</Link>

					<Link :href="route('checkout')" class="btn btn-primary me-2 font-semibold"
						:class="{ 'disabled btn-sm': $store.getters['cart/hasInvalidItems'] }">
					<i class="lnr icon-check"></i> {{ __('proceed_to_checkout') }}
					</Link>

				</div>

			</div>
		</transition>

		<div class="minicart-extended-background" @click="$emit('hide_minicart_extended')"></div>

	</div>

</template>

<script>

import InvalidItemsResolver from "@/Components/ECart/InvalidItemsResolver.vue";
import CartStats from './CartStats.vue';

export default {
	name: "MinicartExtended",
	data: function () {
		return {
			uicontrol: {
				show: false
			},
		}
	},
	components: {
		InvalidItemsResolver,
		CartStats
	},
	emits: ['hide_minicart_extended'],
	mounted() {
		this.uicontrol.show = true;
	}
}
</script>

<style scoped></style>